import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { InitiativeStatusRow } from './blocks/InitiativeStatusRow'
import { Text } from '@app/components/core/typography/Text'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { expandImage, type StoredImage } from '@app/types/StoredImage'
import { Image } from '@app/components/core/image/Image'

export interface MiniCardProps {
  image: string | StoredImage
  location: string
  status?: string
  title: string
  description?: string
  onClick?: () => void
}

export const MiniCard = ({
  image,
  location,
  status,
  title,
  description,
  onClick,
}: MiniCardProps) => {
  const { src, altText } = expandImage(image, `${title} image`)
  return (
    <Row
      gap="0"
      onClick={onClick}
      style={{
        backgroundColor: 'var(--palette-white)',
        borderRadius: '1.25rem',
        overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
        flex: 1,
      }}
    >
      <Image
        src={src || defaultProjectPicture}
        alt={altText}
        style={{
          width: '7.625rem',
        }}
      />

      <Column
        alignItems="stretch"
        style={{
          padding: '1rem',
          borderRadius: '0 1.25rem 1.25rem 0',
          border: 'var(--border-subtle)',
          overflow: 'hidden',
          minWidth: 0,
        }}
      >
        <InitiativeStatusRow location={location} status={status} />
        <Column gap="0.5rem">
          <Title.H5
            style={{
              margin: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {title}
          </Title.H5>
          <Text.Small
            color="var(--palette-blue-300)"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {description}
          </Text.Small>
        </Column>
      </Column>
    </Row>
  )
}
